<div class="detail" [class.visible]="dynamic">
  <div class="close" (click)="close()"></div>
  <div class="dynamic-detail">
    <div *ngIf="!dynamic" class="loading">Loading . . .</div>
    <div *ngIf="dynamic">
      dynamic
    </div>
  </div>
</div>
